import { setDoc, doc, Timestamp, deleteDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase.ts';
import { TimelineReaction } from '../models/TimelineReaction';

export const addOrUpdateTimelineReaction = async (postId: string, userId: string, reactionType: string) => {
  // Ensure we're using a numeric ID
  if (!/^\d+$/.test(userId)) {
    console.error('Attempting to add reaction with non-numeric ID:', userId);
    throw new Error(`Invalid user ID: ${userId}. Only numeric IDs are allowed.`);
  }
  
  const id = `${postId}_${userId}`;
  await setDoc(doc(db, 'timelineReactions', id), {
    id,
    postId,
    userId,
    reactionType,
    created_at: Timestamp.now(),
  });
};

export const removeTimelineReaction = async (postId: string, userId: string) => {
  // Ensure we're using a numeric ID
  if (!/^\d+$/.test(userId)) {
    console.error('Attempting to remove reaction with non-numeric ID:', userId);
    return;
  }
  
  const id = `${postId}_${userId}`;
  await deleteDoc(doc(db, 'timelineReactions', id));
};

export const getReactionsForPost = async (postId: string): Promise<TimelineReaction[]> => {
  if (!postId) return [];
  const q = query(collection(db, 'timelineReactions'), where('postId', '==', postId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => doc.data() as TimelineReaction);
}; 